import { css } from "styled-components";

const ptSerif_hero_base = css`
  font-family: var(--font-pt-serif);
  font-style: normal;
  font-weight: var(--text-weight-bold);
  letter-spacing: 0;
`;

export const ptSerif_hero_lg = css`
  ${ptSerif_hero_base};
  font-size: var(--text-hero-size-lg);
  line-height: 5.2rem;
`;

export const ptSerif_hero_md = css`
  ${ptSerif_hero_base};
  font-size: var(--text-hero-size-md);
  line-height: 4.16rem;
`;

export const ptSerif_hero_sm = css`
  ${ptSerif_hero_base};
  font-size: var(--text-hero-size-sm);
  line-height: 3.64rem;
`;
